

(function () {
  if (window.__kindredTahsisInitialize) {
    window.__kindredTahsisInitialize();
    return;
  }

      var sizes = [
        {length:150, running:1148, noseLength:194, tailLength:176, nose:115, tail:104, waist:80, radius:11.5},
        {length:155, running:1549, noseLength:200, tailLength:180, nose:116, tail:106, waist:83, radius:12.5},
        {length:160, running:1211, noseLength:205, tailLength:184, nose:118, tail:108, waist:85, radius:14},
        {length:165, running:1262, noseLength:205, tailLength:184, nose:122, tail:110, waist:87, radius:14},
        {length:170, running:1301, noseLength:210, tailLength:190, nose:129, tail:119, waist:93, radius:15},
        {length:175, running:1351, noseLength:210, tailLength:190, nose:129, tail:119, waist:93, radius:15},
        {length:180, running:1397, noseLength:214, tailLength:192, nose:134, tail:124, waist:96, radius:16},
        {length:185, running:1447, noseLength:214, tailLength:192, nose:134, tail:124, waist:96, radius:16},
        {length:190, running:1487, noseLength:218, tailLength:196, nose:137, tail:125, waist:97, radius:16.5}
      ];
      var state = { unit: "metric", stage: 1, selected: null, adjustedWaist: null, composite: null };
      var labels = ["", "01 · Standard size", "02 · Waist profile", "03 · Composite", "Your recommendation"];
      var root = null;
      var form = null;

      function initialize(nextRoot) {
        if (!nextRoot) return false;
        if (root !== nextRoot) {
          root = nextRoot;
          form = root.querySelector("#sizingForm");
          state = { unit: "metric", stage: 1, selected: null, adjustedWaist: null, composite: null };
        } else if (!form || !root.contains(form)) {
          form = root.querySelector("#sizingForm");
        }
        if (!form) return false;
        if (root.dataset.tahsisInitialized !== "true") {
          root.dataset.tahsisInitialized = "true";
          renderSpecs();
        }
        return true;
      }

      function initializeExisting() {
        initialize(document.getElementById("kindred-tahsis-tool"));
      }

      function qs(sel) { return root.querySelector(sel); }
      function qsa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
      function value(name) { return Number(qs('input[name="' + name + '"]:checked').value); }
      function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

      function setStage(n) {
        state.stage = n;
        qsa(".stage").forEach(function (el) { el.classList.toggle("active", Number(el.dataset.stage) === n); });
        var visibleStep = Math.min(n, 3);
        qs("#progressLabel").textContent = labels[n];
        qs("#progressCount").textContent = n === 4 ? "Complete" : "Step " + n + " of 3";
        qs("#progressBar").style.width = n === 4 ? "100%" : (visibleStep * 33.333) + "%";
        qs(".wizard").scrollIntoView({ behavior: "smooth", block: "start" });
      }

      function standardIndex(heightCm, weightKg, footCm) {
        var heightIndex = Math.round((heightCm - 155) / 5);
        var weightIndex = Math.round((weightKg - 51) / 7);
        heightIndex = clamp(heightIndex, 0, 8);
        weightIndex = clamp(weightIndex, 0, 8);
        var index = Math.round(heightIndex * 0.68 + weightIndex * 0.32);
        var desiredWaist = footCm < 24 ? 80 : footCm < 25 ? 83 : footCm < 26 ? 85 : footCm < 27 ? 87 : footCm < 28.5 ? 93 : footCm < 30 ? 96 : 97;
        var baseGap = Math.abs(sizes[index].waist - desiredWaist);
        var candidates = [index - 1, index, index + 1].filter(function (i) { return i >= 0 && i < sizes.length; });
        candidates.forEach(function (i) {
          var lengthPenalty = Math.abs(i - index) * 4;
          var gap = Math.abs(sizes[i].waist - desiredWaist) + lengthPenalty;
          if (gap < baseGap) { index = i; baseGap = gap; }
        });
        return index;
      }

      function metricValues() {
        var h = Number(qs("#height").value);
        var w = Number(qs("#weight").value);
        var f = Number(qs("#foot").value);
        if (state.unit === "imperial") {
          h = h * 2.54;
          w = w * 0.45359237;
        }
        return { height: h, weight: w, foot: f };
      }

      function validateBaseline() {
        var v = metricValues();
        var okay = isFinite(v.height) && isFinite(v.weight) && isFinite(v.foot) &&
          v.height >= 120 && v.height <= 220 && v.weight >= 35 && v.weight <= 180 && v.foot >= 20 && v.foot <= 34;
        qs("#stage1Error").textContent = okay ? "" : "Enter a valid height, weight, and ski-boot size.";
        if (okay) state.selected = sizes[standardIndex(v.height, v.weight, v.foot)];
        return okay;
      }

      function convertUnits(next) {
        if (next === state.unit) return;
        var fields = [qs("#height"), qs("#weight")];
        fields.forEach(function (input, i) {
          if (!input.value) return;
          var n = Number(input.value);
          if (next === "imperial") n = i === 1 ? n * 2.20462262 : n / 2.54;
          else n = i === 1 ? n * 0.45359237 : n * 2.54;
          input.value = (Math.round(n * 10) / 10).toString();
        });
        state.unit = next;
        qsa("[data-unit]").forEach(function (b) { b.classList.toggle("active", b.dataset.unit === next); });
        if (next === "metric") {
          qs("#heightUnit").textContent = "cm"; qs("#weightUnit").textContent = "kg"; qs("#footUnit").textContent = "Mondo";
          qs("#height").min = 120; qs("#height").max = 220; qs("#height").placeholder = "178";
          qs("#weight").min = 35; qs("#weight").max = 180; qs("#weight").placeholder = "78";
          qs("#foot").min = 20; qs("#foot").max = 34; qs("#foot").placeholder = "27.5";
        } else {
          qs("#heightUnit").textContent = "inches"; qs("#weightUnit").textContent = "lb"; qs("#footUnit").textContent = "Mondo";
          qs("#height").min = 47; qs("#height").max = 87; qs("#height").placeholder = "70";
          qs("#weight").min = 77; qs("#weight").max = 397; qs("#weight").placeholder = "172";
          qs("#foot").min = 20; qs("#foot").max = 34; qs("#foot").placeholder = "27.5";
        }
      }

      function buildResult() {
        var widthScore = value("terrain") + value("turns") + value("priority");
        var widthDelta = widthScore <= -4 ? -8 : widthScore <= -1 ? -4 : widthScore <= 2 ? 0 : widthScore <= 5 ? 4 : 8;
        var widthDeltas = [-8, -4, 0, 4, 8];
        var waistChoices = widthDeltas.map(function (delta) { return state.selected.waist + delta; });
        state.adjustedWaist = state.selected.waist + widthDelta;
        var compositeScore = value("feel") + value("weightPriority") + value("use");
        state.composite = compositeScore > 0 ? "Carbon Fiber" : "Fiberglass";

        qs("#resultLength").textContent = state.selected.length;
        qs("#resultWaist").textContent = state.adjustedWaist;
        qs("#resultTip").textContent = state.selected.nose + widthDelta;
        qs("#resultTail").textContent = state.selected.tail + widthDelta;
        qs("#resultRadius").textContent = state.selected.radius + " m";
        qs("#resultComposite").textContent = state.composite;
        qs("#compositeTitle").textContent = state.composite;
        qs("#compositeReason").textContent = state.composite === "Carbon Fiber"
          ? "Lower swing weight and a more nimble, immediate response."
          : "Balanced damping and a more forgiving, predictable response.";
        qs("#waistOptions").innerHTML = waistChoices.map(function (waist, index) {
          var delta = widthDeltas[index];
          var recommended = waist === state.adjustedWaist;
          var adjustment = delta === 0 ? "Standard · 0 mm" : (delta > 0 ? "+" : "") + delta + " mm";
          return '<span class="waist-option' + (recommended ? ' recommended' : '') + '">' +
            waist + ' mm' + (recommended ? ' (' + adjustment + ')' : '') + '</span>';
        }).join("");
        highlightSpec(state.selected.length);
      }

      function highlightSpec(length) {
        qsa("[data-size]").forEach(function (el) { el.classList.toggle("selected", Number(el.dataset.size) === Number(length)); });
      }

      function renderSpecs() {
        var rows = [
          ["Running length", "running", " mm"],
          ["Nose length", "noseLength", " mm"],
          ["Tail length", "tailLength", " mm"],
          ["Nose width", "nose", " mm"],
          ["Tail width", "tail", " mm"],
          ["Waist width", "waist", " mm"],
          ["Sidecut radius", "radius", " m"],
          ["Camber profile", null, "Medium Rise"],
          ["Flex pattern", null, "Mid Stiff"]
        ];
        qs("#specBody").innerHTML = rows.map(function (row) {
          return "<tr><td>" + row[0] + "</td>" + sizes.map(function (s) {
            var content = row[1] ? s[row[1]] + row[2] : row[2];
            return '<td data-size="' + s.length + '">' + content + "</td>";
          }).join("") + "</tr>";
        }).join("");
      }

      document.addEventListener("click", function (event) {
        var target = event.target instanceof Element
          ? event.target.closest("[data-unit], [data-next], [data-back], #restart, #viewSpecs")
          : null;
        var targetRoot = target ? target.closest("#kindred-tahsis-tool") : null;
        if (!targetRoot || !initialize(targetRoot)) return;

        if (target.matches("[data-unit]")) {
          convertUnits(target.dataset.unit);
          return;
        }
        if (target.matches("[data-next]")) {
          var next = Number(target.dataset.next);
          if (next === 2 && !validateBaseline()) return;
          setStage(next);
          return;
        }
        if (target.matches("[data-back]")) {
          setStage(Number(target.dataset.back));
          return;
        }
        if (target.id === "restart") {
          form.reset();
          state.selected = null;
          state.adjustedWaist = null;
          state.composite = null;
          highlightSpec(-1);
          setStage(1);
          return;
        }
        if (target.id === "viewSpecs") {
          qs("#specs").scrollIntoView({ behavior: "smooth" });
        }
      });

      document.addEventListener("submit", function (event) {
        var submittedForm = event.target;
        var submittedRoot = submittedForm instanceof Element
          ? submittedForm.closest("#kindred-tahsis-tool")
          : null;
        if (!submittedRoot || submittedForm.id !== "sizingForm" || !initialize(submittedRoot) || submittedForm !== form) return;
        event.preventDefault();
        buildResult();
        setStage(4);
      });

      window.__kindredTahsisInitialize = initializeExisting;
      document.addEventListener("DOMContentLoaded", initializeExisting, { once: true });
      new MutationObserver(initializeExisting).observe(document.documentElement || document, {
        childList: true,
        subtree: true
      });
      initializeExisting();
    })();
